import { mergeLocale} from 'antd-mobile/es/utils/merge-locale'
import { base } from 'antd-mobile/es/locales/base';
const typeTemplate = '${label} ${type} sifatida qabul qilinmaydi';

const arSA = mergeLocale(base, {
  'locale': 'ur-PK',
  common: {
    confirm: 'تصدیق کریں',
    cancel: 'منسوخ کریں',
    loading: 'لوڈ ہو رہا ہے',
    close: 'بند کریں'
  },
  Calendar: {
    title: 'تاریخ منتخب کریں',
    confirm: 'تصدیق کریں',
    start: 'آغاز',
    end: 'اختتام',
    today: 'آج',
    markItems: ['پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ', 'اتوار'],
    yearAndMonth: '${year}/${month}'
  },
  Cascader: {
    placeholder: 'منتخب کریں'
  },
  Dialog: {
    ok: 'ٹھیک ہے'
  },
  DatePicker: {
    tillNow: 'اب تک'
  },
  ErrorBlock: {
    default: {
      title: 'اوہ، کچھ غلط ہو گیا',
      description: 'براہ کرم ایک منٹ انتظار کریں اور دوبارہ کوشش کریں'
    },
    busy: {
      title: 'اوہ، لوڈ نہیں ہو رہا',
      description: 'صفحہ دوبارہ لوڈ کریں'
    },
    disconnected: {
      title: 'نیٹ ورک بند ہے',
      description: 'صفحہ دوبارہ لوڈ کریں'
    },
    empty: {
      title: "اوہ، ہم اسے تلاش نہیں کر سکے...",
      description: 'کیا آپ نئی تلاش کرنا چاہیں گے؟'
    }
  },
  Form: {
    required: 'لازمی',
    optional: 'اختیاری',
    defaultValidateMessages: {
      default: '${label} کے فیلڈ کی تصدیق میں غلطی',
      required: 'براہ کرم ${label} درج کریں',
      enum: '${label} ان میں سے ایک ہونا چاہیے [${enum}]',
      whitespace: '${label} خالی جگہ نہیں ہو سکتی',
      date: {
        format: '${label} کی تاریخ کا فارمیٹ غلط ہے',
        parse: '${label} کو تاریخ میں تبدیل نہیں کیا جا سکتا',
        invalid: '${label} غلط تاریخ ہے'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label} ${len} حروف کا ہونا چاہیے',
        min: '${label} کم از کم ${min} حروف کا ہونا چاہیے',
        max: '${label} زیادہ سے زیادہ ${max} حروف کا ہونا چاہیے',
        range: '${label} ${min}-${max} حروف کے درمیان ہونا چاہیے'
      },
      number: {
        len: '${label} ${len} کے برابر ہونا چاہیے',
        min: '${label} کم از کم ${min} ہونا چاہیے',
        max: '${label} زیادہ سے زیادہ ${max} ہونا چاہیے',
        range: '${label} ${min}-${max} کے درمیان ہونا چاہیے'
      },
      array: {
        len: '${label} ${len} آئٹمز کا ہونا چاہیے',
        min: '${label} کم از کم ${min} آئٹمز کا ہونا چاہیے',
        max: '${label} زیادہ سے زیادہ ${max} آئٹمز کا ہونا چاہیے',
        range: '${label} کی مقدار ${min}-${max} کے درمیان ہونا چاہیے'
      },
      pattern: {
        mismatch: '${label} ${pattern} کے معیار پر پورا نہیں اترتا'
      }
    }
  },
  ImageUploader: {
    uploading: 'لوڈ ہو رہا ہے...',
    upload: 'اپ لوڈ کریں'
  },
  InfiniteScroll: {
    noMore: 'مزید معلومات نہیں ہیں',
    failedToLoad: 'لوڈ کرنے میں ناکام',
    retry: 'دوبارہ کوشش کریں'
  },
  Input: {
    clear: 'صاف کریں'
  },
  Mask: {
    name: 'ماسک'
  },
  Modal: {
    ok: 'ٹھیک ہے'
  },
  PasscodeInput: {
    name: 'پاس کوڈ درج کریں'
  },
  PullToRefresh: {
    pulling: 'تازہ کرنے کے لیے نیچے کھینچیں',
    canRelease: 'فوری تازہ کاری کے لیے چھوڑیں',
    complete: 'تازہ کاری کامیابی سے مکمل ہو گئی'
  },
  SearchBar: {
    name: 'تلاش پینل'
  },
  Slider: {
    name: 'سلائیڈر'
  },
  Stepper: {
    decrease: 'کم کریں',
    increase: 'بڑھائیں'
  },
  Switch: {
    name: 'سوئچ'
  },
  Selector: {
    name: 'منتخب کنندہ'
  }
});
export default arSA;